import React from "react";
import Style from "../../styles/pages/PoliticaTermos.module.css"

const ExcluirConta = () => {
  return (
    <div className={Style.politicaContainer}>
      <p className={Style.politicaData}>Última atualização: 30/05/2025</p>

      <h2>Solicitação de Exclusão de Conta e Dados</h2>

      <p>
        Esta página foi criada para permitir que usuários da plataforma <strong>LesVita</strong> solicitem a exclusão de suas contas e dados pessoais conforme previsto na Lei Geral de Proteção de Dados (LGPD) e nos requisitos das lojas de aplicativos.
      </p>

      <section>
        <h3>Como excluir sua conta</h3>
        <p>Você pode excluir sua conta de duas formas:</p>
        <ol>
          <li>
            <strong>Pelo próprio aplicativo:</strong> Acesse sua área de perfil e clique em <em>"Excluir meus dados"</em> para remover sua conta de forma automática.
          </li>
          <li>
            <strong>Via solicitação manual:</strong> Envie um e-mail para <a href="mailto:suporte@lesvita.com">suporte@lesvita.com</a> com o assunto <strong>"Solicitação de exclusão de conta"</strong>, informando seu CPF ou e-mail cadastrado.
          </li>
        </ol>
      </section>

      <section>
        <h3>Dados excluídos</h3>
        <p>
          Ao solicitar a exclusão, os seguintes dados serão permanentemente removidos:
        </p>
        <ul>
          <li>Informações de cadastro (nome, CPF, e-mail, telefone);</li>
          <li>Histórico de avaliações físicas e imagens;</li>
          <li>Objetivos e dados de saúde fornecidos;</li>
          <li>Planos gerados (treino e dieta);</li>
          <li>Histórico de agendamentos e consultas;</li>
          <li>Mensagens com profissionais.</li>
        </ul>

        <p><strong>Importante:</strong> essa ação é irreversível e todos os dados serão permanentemente apagados dos nossos servidores.</p>
      </section>

      <section>
        <h3>Prazo para exclusão</h3>
        <p>
          Após a solicitação, os dados serão excluídos no prazo de até <strong>60 dias</strong> para solicitações manuais, ou imediatamente via app.
        </p>
      </section>

      <section>
        <h3>Contato</h3>
        <p>
          Em caso de dúvidas sobre esse processo, envie um e-mail para <a href="mailto:suporte@lesvita.com">suporte@lesvita.com</a>.
        </p>
      </section>
    </div>
  );
};

export default ExcluirConta;
